import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-textInput-control-label-view, [app-textInput-control-label-view]',
  templateUrl: './textInput-control-label-view.component.html',
  styleUrls: ['./textInput-control-label-view.component.scss']
})
export class TextInputControlLabelViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
